function getTemperatureUnit(type) {
    if (type === "SI") {
      return ' ºC'; // Celsius symbol
    } else if (type === "Imperial") {
      return ' ºF'; // Fahrenheit symbol
    }
    return ''; // Default to an empty string if type is neither "SI" nor "Imperial"
  }
  
  export default getTemperatureUnit;
  